"use strict";

exports.__esModule = true;
exports.DeviceMapThumbnail = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _Measures = require("../../Measures");
var _TextValue = require("../../Measures/TextValue");
var _PlantStateActivities = require("../../PlantStateActivities");
var _class, _DeviceMapThumbnail;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Thumbnail for DevicePropertyWidget.
 */
var DeviceMapThumbnail = exports.DeviceMapThumbnail = (0, _styledComponents.withTheme)(_class = (_DeviceMapThumbnail = /*#__PURE__*/function (_Component) {
  function DeviceMapThumbnail() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DeviceMapThumbnail, _Component);
  var _proto = DeviceMapThumbnail.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      fontFamily = _this$props.fontFamily,
      fontSize = _this$props.fontSize,
      fontWeight = _this$props.fontWeight,
      fontStyle = _this$props.fontStyle,
      backgroundColorSource = _this$props.backgroundColorSource,
      propertyName = _this$props.propertyName,
      theme = _this$props.theme,
      x = _this$props.x,
      y = _this$props.y,
      width = _this$props.width,
      height = _this$props.height;
    var value = propertyName === "name" ? "Device 123" : "123-XYZ-789";
    var backgroundColor;
    if (backgroundColorSource) {
      if (backgroundColorSource.type === "metric") {
        var thresholds = backgroundColorSource.thresholds;
        var min = thresholds[0][0];
        var max = thresholds[thresholds.length - 1][0];
        var _value = min + Math.random() * (max - min);
        backgroundColor = (0, _Measures.getThresholdColor)(thresholds, _value);
      } else if (backgroundColorSource.type === "cycle") {
        var plantStateColors = (0, _PlantStateActivities.getPlantStateColors)(theme);
        var stateIds = Object.keys(plantStateColors);
        backgroundColor = plantStateColors[stateIds[Math.floor(Math.random() * stateIds.length)]];
      } else {
        var _plantStateColors = (0, _PlantStateActivities.getPlantStateColors)(theme);
        var rand = Math.random();
        if (rand > 0.9) {
          backgroundColor = _plantStateColors["downtime.planned"];
        } else if (rand > 0.7) {
          backgroundColor = _plantStateColors.setup;
        } else {
          backgroundColor = _plantStateColors.producing;
        }
      }
    }
    return /*#__PURE__*/_react["default"].createElement(_TextValue.TextValue, {
      x: x,
      y: y,
      width: width,
      height: height,
      backgroundColor: backgroundColor,
      value: value,
      fontSize: fontSize,
      fontWeight: fontWeight,
      fontStyle: fontStyle,
      fontFamily: fontFamily
    });
  };
  return DeviceMapThumbnail;
}(_react.Component), _DeviceMapThumbnail.defaultProps = {
  x: 0,
  y: 0,
  theme: undefined
}, _DeviceMapThumbnail)) || _class;